document.addEventListener("readystatechange", (event) => {
  if(document.readyState === "interactive") {

    function parseEasternTime(str) {

      //Expected format: "YYYY-MM-DD HH:MM:SS"
      const [datePart, timePart] = str.split(" ");
      const [year, month, day] = datePart.split("-").map(Number);
      const [hour, minute, second] = timePart.split(":").map(Number);

      //Build ISO string - assume Eastern Daylight always (default -04:00)
      let isoString = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}T${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}:${String(second).padStart(2, "0")}-04:00`;

      return new Date(new Date(isoString).toLocaleString("en-US", { timeZone: "America/New_York" }));
    }

    function initCountdown(countdownTimer) {
      const endTime = parseEasternTime(countdownTimer.dataset.endTime).getTime();
      const isNan = Number.isNaN(endTime);

      let interval;

      //Check NaN for Safari - return and display 0 if true.
      if(isNan == true) return;

      function updateCountdown() {
        const now = Date.now();
        const distance = endTime - now;

        //If the countdowns over
        if (distance <= 0) {

          //Stop interval
          clearInterval(interval);
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        countdownTimer.querySelector("#days").textContent = String(days).padStart(2, "0");
        countdownTimer.querySelector("#hours").textContent = String(hours).padStart(2, "0");
        countdownTimer.querySelector("#minutes").textContent = String(minutes).padStart(2, "0");
        countdownTimer.querySelector("#seconds").textContent = String(seconds).padStart(2, "0");

        //Hide double zeros from days if there are no days left.
        if(days == 0 && distance > 0) {
          countdownTimer.querySelector("#days")?.classList.add("hidden");
          countdownTimer.querySelector(".announcement-bar__time-divider-days")?.classList.add("hidden");
        }
      }

      updateCountdown();
      interval = setInterval(updateCountdown, 1000);
    }

    //Loop over all countdown timers
    document.querySelectorAll(".announcement__countdown-timer").forEach(initCountdown);
  }
});

//Sticky scrolling function
//Since blocks inside `blocks/` folder cant talk to their parent Sections via Liquid, use JS to add classes to parent elements
//These classes tell the Header how much room to leave for each announcement bar when going sticky during scroll
//There are several possible combinations, since some announcement bars on mobile can break to 2 lines and double their height.
function sticky() {
  let lastScrollY = window.scrollY;

  const body = document.querySelector("body");
  const headerComponent = document.querySelector("header-component");
  const stickyAnnouncementBarTotal = document.querySelectorAll(".announcement-bar--sticky");
  const announcementBarsThatAreStickyArray = Array.from(stickyAnnouncementBarTotal);

  //Variable mobile height class addition
  //Communicate from the block level up to the section level that we need a mobile break
  const mobileHeight = document.querySelectorAll(".mobile-break--true");

  //Check if one of the announcement bars has a line break for mobile
  //If so, add a class for extra height on sticky scroll
  if(mobileHeight && mobileHeight?.length > 0) {
    mobileHeight?.forEach((announcementBar => {
      const announcementParent = announcementBar.closest(".announcement-bar");
            announcementParent.classList.add("mobile-line-break");
      
      const announcementIndex = announcementParent.dataset.announcementIndexPosition;
      body?.classList.add(`slide--${announcementIndex}-mobile-break`);
    }));

    const header = document.querySelector("header");
          header.classList.add("mobile-line-break");
  }

  if(announcementBarsThatAreStickyArray.length > 0) {

    window.addEventListener("scroll", () => {
      
      //Scroll is approaching the top of page
      if(window.scrollY <= 0) {
        announcementBarsThatAreStickyArray[0]?.parentElement.classList.remove("scrolling");
        announcementBarsThatAreStickyArray[0]?.parentElement.classList.remove("hide");

        headerComponent.dataset.stickyState = "inactive";

        body?.classList.remove("scrolling-active");
        body?.classList.remove("header-sticky");

        if(stickyAnnouncementBarTotal.length == 1) {
          body?.classList.remove("one-announcement");
        }
        else if(stickyAnnouncementBarTotal.length == 2) {
          body?.classList.remove("two-announcements");

          announcementBarsThatAreStickyArray[1]?.parentElement.classList.remove("second-scrolling");
          announcementBarsThatAreStickyArray[1]?.parentElement.classList.remove("hide");
        }
      }
      //Scrolling Upwards
      else {
        announcementBarsThatAreStickyArray[0]?.parentElement.classList.remove("hide");
        announcementBarsThatAreStickyArray[0]?.parentElement.classList.add("scrolling");

        //Force Header to have active state
        headerComponent.dataset.stickyState = "active";

        body?.classList.add("scrolling-active");
        body?.classList.add("header-sticky");

        if(stickyAnnouncementBarTotal.length == 1) {
          body?.classList.add("one-announcement");
        }
        else if(stickyAnnouncementBarTotal.length == 2) {
          body?.classList.add("two-announcements");

          announcementBarsThatAreStickyArray[1]?.parentElement.classList.remove("hide");
          announcementBarsThatAreStickyArray[1]?.parentElement.classList.add("second-scrolling");
        }
      }

      lastScrollY = window.scrollY;
    });
  }
}

sticky();